// extracted by mini-css-extract-plugin
export var o_warning = "warning-module--o_warning--5e33c";